import { render, staticRenderFns } from "./BulkPlacementFeeUpload.vue?vue&type=template&id=5f1ac4a3"
import script from "./BulkPlacementFeeUpload.vue?vue&type=script&lang=ts"
export * from "./BulkPlacementFeeUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports